export default __webpack_public_path__ + "e2fd1dcd39dd4bcce89cfbf9ee288041.svg";